import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { agregarTarea } from "../../../features/registroTareasSlice";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// Material UI y Lucide
import { 
  Box, Typography, TextField, Grid, Button, Paper, 
  Stack, FormControlLabel, Checkbox, Divider, Chip
} from "@mui/material";
import { PlusCircle, Share2, Calendar, MessageSquare, Target, Megaphone } from "lucide-react";

const apiUrl = process.env.REACT_APP_API_BASE_URL;

const PALETTE = { 
  ice: "#C2EDF0", 
  aqua: "#00C0CA", 
  teal: "#008B9C", 
  dark: "#22404D", 
  slate: "#94A3B8",
  pearl: "#EEF3F4"
};

const PublicacionRedes = ({ idPedido }) => {
    // ==========================================
    // LÓGICA ORIGINAL (MANTENIDA)
    // ==========================================
    const tareas = useSelector(state => state.tareas.Tareas);
    const dispatch = useDispatch();
    const [formPublicacionRedes, setFormPublicacionRedes] = useState({
        tipoTarea: "PublicacionRedes",    
        descripcionPosteo: "",
        fechaLimite: "",
        campania: false,
        pauta: false
    });

    const [mostrarFormulario, setMostrarFormulario] = useState(true); 

    const handleChange = (e) => {
        const { name, value, type } = e.target;
        let newValue;
        
        if (type === 'checkbox') {
            newValue = e.target.checked;
        } else {
            newValue = value;
        }
    
        setFormPublicacionRedes({
            ...formPublicacionRedes,
            [name]: newValue
        });
    };

    const validar = () => {
        const { descripcionPosteo, fechaLimite } = formPublicacionRedes;
        const fechaFormulario = new Date(fechaLimite);
        const fechaActual = new Date();
        fechaActual.setHours(0, 0, 0, 0);
        fechaFormulario.setHours(0, 0, 0, 0);

        if (!descripcionPosteo) return "La descripción del posteo no puede estar vacía.";
        if (!fechaLimite) return "La fecha límite no puede estar vacía.";
        if (fechaFormulario < fechaActual) return "La fecha límite debe ser una fecha futura.";
        return "";
    };

    const agregarTareaAlPedido = async () => {
        const mensaje = validar();
        if (mensaje !== "") {
            toast.error(mensaje, { position: "bottom-center", autoClose: 3000 });
            return;
        }

        const { descripcionPosteo, fechaLimite, campania, pauta } = formPublicacionRedes;
        const registro = {
            id: tareas.length + 1,
            tipoTarea: "PublicacionRedes",
            comentario:"",
            descripcionPosteo,
            fechaLimite,
            campania,
            pauta,
            estado: "pendiente"
        };

        if (idPedido) {
            const respuesta = await fetch(`${apiUrl}/Tarea/AgregarTareaPublicacionRedes?IdPedido=${idPedido}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'apiKey': localStorage.getItem("apiKey")   
                },
                body: JSON.stringify(registro)
            });

            if (respuesta.ok) {
                setMostrarFormulario(false);
                toast.success('Pedido agregado correctamente', { position: "bottom-center", autoClose: 3000 });
            }
        } else {
            dispatch(agregarTarea(registro));
            setMostrarFormulario(false); 
            toast.success('Tarea agregada correctamente', { position: "bottom-center", autoClose: 3000 });
        }
    };
    // ==========================================

    if (!mostrarFormulario) return null;

    return (
        <Paper 
            elevation={0} 
            sx={{ 
                p: 3, 
                borderRadius: '24px', 
                bgcolor: PALETTE.pearl, 
                border: `1px solid ${PALETTE.ice}`,
                mt: 2,
                animation: 'fadeIn 0.3s ease-in-out'
            }}
        >
            <Stack spacing={2.5}>
                <Box display="flex" alignItems="center" gap={1}>
                    <Share2 size={20} color={PALETTE.teal} />
                    <Typography variant="subtitle2" sx={{ fontWeight: 800, color: PALETTE.dark }}>
                        Detalles de Redes Sociales
                    </Typography>
                </Box>

                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Typography variant="caption" sx={{ fontWeight: 800, ml: 1, color: PALETTE.slate }}>DESCRIPCIÓN DEL POSTEO</Typography>
                        <TextField 
                            fullWidth 
                            multiline
                            rows={3}
                            name="descripcionPosteo" 
                            value={formPublicacionRedes.descripcionPosteo} 
                            onChange={handleChange} 
                            placeholder="Escribe aquí el copy o detalles del posteo..."
                            InputProps={{ startAdornment: <MessageSquare size={16} style={{marginRight: 12, marginTop: -40, color: PALETTE.slate}} /> }}
                            sx={{ mt: 0.5, "& .MuiOutlinedInput-root": { borderRadius: '16px', bgcolor: 'white' } }} 
                        />
                    </Grid>

                    <Grid item xs={12} sm={6}>
                        <Typography variant="caption" sx={{ fontWeight: 800, ml: 1, color: PALETTE.slate }}>FECHA DE PUBLICACIÓN</Typography>
                        <TextField 
                            fullWidth 
                            type="date" 
                            name="fechaLimite" 
                            value={formPublicacionRedes.fechaLimite} 
                            onChange={handleChange} 
                            inputProps={{ min: new Date().toISOString().split('T')[0] }}
                            sx={{ mt: 0.5, "& .MuiOutlinedInput-root": { borderRadius: '12px', bgcolor: 'white' } }} 
                        />
                    </Grid>

                    <Grid item xs={12} sm={6}>
                         <Box sx={{ mt: 2, p: 1, bgcolor: 'rgba(0,0,0,0.02)', borderRadius: '12px' }}>
                            <Stack direction="row" spacing={1} justifyContent="center">
                                <FormControlLabel
                                    control={
                                        <Checkbox 
                                            name="campania" 
                                            checked={formPublicacionRedes.campania} 
                                            onChange={handleChange}
                                            sx={{ color: PALETTE.teal, '&.Mui-checked': { color: PALETTE.teal } }}
                                        />
                                    }
                                    label={
                                        <Box display="flex" alignItems="center" gap={0.5}>
                                            <Target size={14} />
                                            <Typography variant="caption" sx={{ fontWeight: 700 }}>Campaña</Typography>
                                        </Box>
                                    }
                                />
                                <FormControlLabel
                                    control={
                                        <Checkbox 
                                            name="pauta" 
                                            checked={formPublicacionRedes.pauta} 
                                            onChange={handleChange}
                                            sx={{ color: PALETTE.teal, '&.Mui-checked': { color: PALETTE.teal } }}
                                        />
                                    }
                                    label={
                                        <Box display="flex" alignItems="center" gap={0.5}>
                                            <Megaphone size={14} />
                                            <Typography variant="caption" sx={{ fontWeight: 700 }}>Pauta</Typography>
                                        </Box>
                                    }
                                />
                            </Stack>
                         </Box>
                    </Grid>
                </Grid>

                <Button 
                    variant="contained" 
                    fullWidth 
                    onClick={agregarTareaAlPedido}
                    startIcon={<PlusCircle size={18} />}
                    sx={{ 
                        mt: 1, 
                        borderRadius: '12px', 
                        py: 1.2, 
                        fontWeight: 800, 
                        bgcolor: PALETTE.teal,
                        '&:hover': { bgcolor: PALETTE.dark }
                    }}
                >
                    Añadir Publicación
                </Button>
            </Stack>
        </Paper>
    );
};

export default PublicacionRedes;